/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import moment from "moment";

require('./bootstrap');

import Vue from 'vue'
import Scrollspy, {Easing} from 'vue2-scrollspy';
import VueScrollTo from 'vue-scrollto';

import ClipboardJS from 'clipboard'
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import MaxLengthInput from './components/forms/MaxLengthInput.vue'
import Wysiwyg from './components/forms/Wysiwyg.vue'
import Dropdown from './components/layout/Dropdown.vue'
import DropdownClick from './components/layout/DropdownClick.vue'
import Modal from './components/layout/Modal.vue'
import MaxLengthTextarea from './components/forms/MaxLengthTextarea.vue'
import AppNotifications from './components/AppNotifications/AppNotifications.vue'
import inputPassword from './components/forms/inputPassword.vue'
import Tabs from './components/layout/Tabs.vue'
import Tab from './components/layout/Tab.vue'
import Accordion from './components/layout/Accordion.vue'
import OrderSummaryTable from './components/tables/OrderSummaryTable.vue'
import FileUploader from './components/forms/FileUploader.vue'
import FileUploaderCropper from "./components/forms/FileUploaderCropper";
import BadgeForm from './components/forms/BadgeForm.vue'
import ExtendedBadgeForm from './components/forms/ExtendedBadgeForm.vue'
import CompanyForm from './components/forms/CompanyForm.vue'
import StartupForm from './components/forms/StartupForm.vue'
import Snackbar from './components/AppNotifications/Snackbar.vue'
import ToggleFavoriteButton from './components/forms/ToggleFavoriteButton.vue'
import ToggleVerifiedButton from "./components/forms/ToggleVerifiedButton"
import ToggleValidatedButton from "./components/forms/ToggleValidatedButton"
import ToggleStatusButton from './components/forms/ToggleStatusButton'
import ToggleButton from './components/forms/ToggleButton.vue'
import searchSelect from './components/forms/searchSelect.vue'
import searchSelectTooltip from "./components/forms/searchSelectTooltip";
import SimpleSearchSelect from './components/forms/SimpleSearchSelect.vue'
import DeleteConfirmButton from './components/forms/DeleteConfirmButton.vue'
import ContactLunch from './components/forms/ContactLunch.vue'
import cvlibMultiSelect from './components/forms/cvlibMultiSelect.vue'
import AddUpdateDeleteForm from './components/forms/AddUpdateDeleteForm.vue'
import StandConfigFurnitureForm from './components/forms/StandConfigFurnitureForm.vue'
import CvlibPackForm from './components/forms/CvlibPackForm.vue'
import DayTimeRangeForm from "./components/forms/DayTimeRangeForm"
import OverlappedDayTimeRangeForm from "./components/forms/OverlappedDayTimeRangeForm"
import Vstyle from './components/Vstyle.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import scrollSnapPolyfill from 'css-scroll-snap-polyfill'
import VueBrowserUpdate from 'vue-browserupdate'
import Validations from './components/validations/validations'
import CompanyValidations from "./components/validations/company_validations";
import VueTippy, {TippyComponent} from "vue-tippy";

window.Vue = Vue;

Vue.use(VueBrowserUpdate, {
    options: {
        // Your browser update options
        container: document.body,
    },
});

Vue.use(Scrollspy, {
    easing: Easing.Exponential.Out
});

Vue.use(VueScrollTo, {
    offset: -100
});

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);


var vm = new Vue({
    el: "#app",
    data: {
        enabled: true, // generic attribute
        disabled: false, // generic attribute
        counts: {}, // generic attribute
        section: 0,
        snackbars: [
            /* {id: 1, content: 'Notification neutre', type: "info", isOpen: false, autoDestroy: 5},
             {id: 2, content: 'Notification de succès', type: "success", isOpen: false, autoDestroy: 10},
             {id: 3, content: 'Notification d\'échec', type: "error", isOpen: false},*/
        ],
        WYSIWYGcustomToolbar: [
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['image', 'code-block']
        ],
        optionalDisplay:
            {'suscribeconfirmationmodal': false},
        withEcoTax: false,
        withNGOSupport: false,
        subConfirmation: false,
        submitting: false,
        config: {
            stand: {
                days: {},
                size_limits_limit: {},
                size_quantity_total: {},
                size_limits_initial_total: 0,
                formatted_days: {},
            },
            lunch: {
                days: {}
            },
            startup_stand: {
                day: null,
                size_limits_limit: {},
                size_quantity_total: {},
                size_limits_initial_total: 0
            },
            ong_stand: {
                day: null,
                size_limits_limit: {},
                size_quantity_total: {},
                size_limits_initial_total: 0
            },
            lodge: {
                days: {},
                studyLevels: {}
            },
            contactLunch: {
                days: {}
            },
            startup_presentation: {
                aperitifs: {},
                available_room_periods: {},
                edition_room_periods: {},
                studyLevels: {}
            },
            presentation: {
                aperitifs: {},
                available_room_periods: {},
                edition_room_periods: {},
                studyLevels: {}
            },
            workshop: {
                aperitifs: {},
                available_room_periods: {},
                edition_room_periods: {},
                studyLevels: {}
            },
        },
        subscription: {
            stand: {
                type: null,
                name: null,
                days: {},
                availabilities: null,
                lunch_included: null,
                size: null
            },
            lunch: {
                days: {},
            },
            lodge: {
                name: null,
                description: null,
                type: null,
                study_levels: {},
                days: {}
            },
            startup_presentation: {
                duration: null,
                study_levels: {},
                day: null,
                room: null,
                slot: null,
                name: null,
                company_name: "",
                description: null,
                speaker: null,
                language: null
            },
            presentation: {
                duration: null,
                study_levels: {},
                day: null,
                room: null,
                slot: null,
                name: null,
                company_name: "",
                description: null,
                speaker: null,
                language: null
            },
            workshop: {
                duration: null,
                study_levels: {},
                day: null,
                room: null,
                slot: null,
                name: null,
                company_name: "",
                description: null,
                accept_invites: null,
                speaker: null,
                language: null
            },
            contact_lunch: {
                name: "",
                lunches: {},
                extra: {}
            }
        },
        student: {
            firstname: '',
            lastname: '',
            picture: '',
            email: '',
            communication_email: '',
            phone: '',
            birth_date: '',
            gender: '',
            study_level: '',
            study_section: '',
            study_minor_section: '',
            job_types: [],
            languages: [],
            linkedin: '',
            portfolio: '',
        },
        job_types_map: {},
        languageNames: [],
        levelNames: [],
        has_portfolio: [],
        favorites: {},
        verified: {},
        validated: {},
        statuses: {},
        cvlib: {
            export: 0,
            selectedStudents: {},
            studentsToInvite: {},
            selectedActivity: {
                id: null
            },
            toAccept: null,
            toCancel: null,
            toMessage: null,
            toDelete: null,
            cancelFrom: null,
            showCancelWarning: false,
            toDecline: null,
            toAskForChange: null,
            toAskNewInvite: null,
            toBook: {
                id: null,
                name: null,
                status: null,
                date: null,
                time: null,
                preference: null,
            }
        },
        search: {
            selectedItems: {}
        },
        admin: {
            selectCompany: null,
            toUnsubscribe: null,
            toDelete: null,
            toDeleteRoute: null,
            selectedRole: null,
            setSponsor: null,
            setPreviousSponsor: null
        },
        register: null,
        cancelRequest: null,
        acceptInvitation: null,
        declineInvitation: null,
        askForChange: null,
        askNewInvite: null,
        sendMessage: null,
        withPrefs: false,
        bill: {
            status: '',
            expire_at: null
        }
    },
    mounted: function () {
        scrollSnapPolyfill()
    },
    computed: {
        standElementSizes() {
            var result = [];

            for (let elem of this.$refs['stand_sizes'].elements) {
                if (elem.size !== null && elem.size !== '' && result.indexOf(parseInt(elem.size)) === -1) {
                    result.push(parseInt(elem.size));
                }
            }

            return result;
        },
        studentProfileJobs() {
            var result = [];
            for (let selectedJob of this.student.job_types) {
                result.push(this.job_types_map[selectedJob]);
            }

            return result.sort().join(", ");
        },
        studentProfileLanguages() {
            var result = [];

            for (let language of this.student.languages) {
                result.push({
                    "language": this.languageNames[language.languages],
                    "level": this.levelNames[language.level],
                });
            }

            return result;
        },
        hasPortfolio() {
            return this.student.study_section ? (this.has_portfolio[this.student.study_section].has_portfolio == true) : false
        },
        portfolioTitle() {
            return this.student.study_section ? this.has_portfolio[this.student.study_section].title : ''
        },
        selectedPresentationRoomPeriods() {
            var result = {};
            for (let room_period in this.config.presentation.available_room_periods) {
                if (this.config.presentation.edition_room_periods[room_period])
                    result[room_period] = this.config.presentation.available_room_periods[room_period];
            }
            return result;
        },
        selectedWorkshopRoomPeriods() {
            var result = {};
            for (let room_period in this.config.workshop.available_room_periods) {
                if (this.config.workshop.edition_room_periods[room_period])
                    result[room_period] = this.config.workshop.available_room_periods[room_period];
            }
            return result;
        },
        isStandComplete() {
            return this.subscription.stand.name
                && this.subscription.stand.type
                && (Object.keys(this.subscription.stand.days).length > 0)
                && (Object.values(this.subscription.stand.days).indexOf(true) > -1)
                && this.subscription.stand.size
        },
        isPresentationComplete() {
            return this.subscription.presentation.name
                && this.subscription.presentation.duration
                && this.subscription.presentation.description
                && this.subscription.presentation.speaker
                && this.subscription.presentation.language
                && this.subscription.presentation.day
                && this.subscription.presentation.room
                && this.subscription.presentation.slot
        },
        isWorkshopComplete() {
            return this.subscription.workshop.name
                && this.subscription.workshop.duration
                && this.subscription.workshop.description
                && this.subscription.workshop.speaker
                && this.subscription.workshop.language
                && this.subscription.workshop.day
                && this.subscription.workshop.room
                && this.subscription.workshop.slot
                && (this.subscription.workshop.accept_invites != null)
        },
        isLodgeComplete() {
            return this.subscription.lodge.name
                && this.subscription.lodge.type
                && (Object.keys(this.subscription.lodge.days).length > 0)
                && (Object.values(this.subscription.lodge.days).indexOf(true) > -1)
        },
        isContactLunchComplete() {
            return this.subscription.contact_lunch.name
                && (Object.keys(this.subscription.contact_lunch.lunches).length > 0)
                && (Object.values(this.subscription.contact_lunch.lunches).reduce((pv, cv) => pv + cv, 0) > 0);
        }
    },
    components: {
        MaxLengthInput,
        Wysiwyg,
        Dropdown,
        DropdownClick,
        Modal,
        MaxLengthTextarea,
        AppNotifications,
        inputPassword,
        Tabs,
        Tab,
        Accordion,
        OrderSummaryTable,
        FileUploader,
        FileUploaderCropper,
        BadgeForm,
        ExtendedBadgeForm,
        CompanyForm,
        StartupForm,
        Snackbar,
        searchSelect,
        searchSelectTooltip,
        SimpleSearchSelect,
        ToggleFavoriteButton,
        ToggleVerifiedButton,
        ToggleValidatedButton,
        ToggleStatusButton,
        ToggleButton,
        DeleteConfirmButton,
        ContactLunch,
        cvlibMultiSelect,
        AddUpdateDeleteForm,
        StandConfigFurnitureForm,
        CvlibPackForm,
        Vstyle,
        vSelect,
        Validations,
        CompanyValidations,
        DayTimeRangeForm,
        OverlappedDayTimeRangeForm
    },
    methods: {
        markAsRead(route, id) {
            axios.post(route, {
                    'notification': id
                }
            ).then((response) => {
                console.log(response);
            }).catch(function (error) {
                // error management?
                console.log(error);
            });
        },
        reportFormValidity(ref) {
            return this.$refs[ref].reportValidity();
        },
        toggleAModal(ref) {
            this.$refs[ref].toggleModal()
        },
        toggleSubmitting() {
            this.submitting = true
            this.$refs.registercompanyforeditionform.submit();
        },
        needsDisplay: function (ref) {
            if (this.optionalDisplay[ref]) {
                return this.optionalDisplay[ref];
            } else {
                return false;
            }
        },
        setOptionalDisplay: function (ref, value) {
            this.optionalDisplay[ref] = value;
        },
        resetSubscriptionForm: function (ref, value) {
            this.optionalDisplay[ref] = value;
            this.withEcoTax = false;
            this.withNGOSupport = false;
            this.subConfirmation = false;
        },
        updateOrderItem: function (ref, type, id, active, linked) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItem(type, id, active, linked);
            }
        },
        updateOrderItemQuantity: function (ref, type, id, quantity) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItemQuantity(type, id, quantity);
            }
        },
        updateOrderItemDiscount: function (ref, type, id, discount) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].updateOrderItemDiscount(type, id, discount);
            }
        },
        toggleOrderDay: function (ref, id, active) {
            let refs = ref.split(',');
            for (let i = 0; i < refs.length; i++) {
                this.$refs[refs[i]].toggleOrderDay(id, active);
            }
        },

        standSizeIsAvailable: function (size) {

            if (Object.keys(this.subscription.stand.days).length === 0) return false;

            for (var day in this.subscription.stand.days) {

                if (this.subscription.stand.days[day]) {
                    if (this.subscription.stand.availabilities[day].indexOf(size) < 0) {
                        return false;
                    }
                }
            }
            return true;
        },
        deselectAllCheckedItems: function (ref) {
            if (this.$refs[ref]) {
                var items = this.$refs[ref].getElementsByTagName('input');
                for (let item of items) {
                    if (item.checked) {
                        item.checked = false;
                        item.dispatchEvent(new Event('change'));
                    }
                }

            }
        },
        deselectItemsWithDataId: function (ref, id) {
            if (this.$refs[ref]) {
                var items = this.$refs[ref].getElementsByTagName('input');
                for (let item of items) {
                    if (item.dataset.id == id) {
                        item.setAttribute('value', 0);
                        item.dispatchEvent(new Event('change'));
                    }
                }
                //this.$refs[ref + "-" + dayId].setAttribute('value', 0);
            }

        },
        standHasSelectedDays: function () {
            for (var day in this.subscription.stand.days) {
                if (this.subscription.stand.days[day]) {
                    return true;
                }
            }
            return false;
        },
        addStandDay: function (day) {
            const formattedDate = moment(day.day);
            this.config.stand.formatted_days[day.id] = formattedDate.format('DD.MM.YYYY');
            this.config.stand.size_limits_limit = {
                ...this.config.stand.size_limits_limit,
                [day.id]: {},
            };
            this.config.stand.size_limits_initial_total[day.id] = 0;
        },
        toggleStudyLevels: function (ref, target) {
            if (this.$refs[ref]) {
                var items = this.$refs[ref].getElementsByTagName('input');

                if (target.dataset.selector == "all") {
                    if (target.checked) {
                        for (let item of items) {
                            if (item.checked && item != target) {
                                item.checked = false;
                            }
                        }
                    } else {
                        //If you try to deselect the all, it auto reselect
                        target.checked = true;
                    }

                } else {
                    if (target.checked) {
                        for (let item of items) {
                            if (item.dataset.selector == "all") {
                                item.checked = false;
                            }
                        }
                    } else {
                        var hasStillChecked = false;
                        var allLevels = null;
                        for (let item of items) {
                            if (item.dataset.selector == "all") {
                                allLevels = item;
                            } else {
                                if (item.checked) {
                                    hasStillChecked = true;
                                }
                            }
                        }
                        if (!hasStillChecked) {
                            allLevels.checked = true;
                        }

                    }
                }

            }
        },
        isTimeBetween(slotTime, startTime, endTime) {

            if (slotTime == null) return false;

            var t1 = new Date();
            var parts = slotTime.split(":");
            t1.setHours(parts[0], parts[1], 0, 0);

            var t2 = new Date();
            parts = startTime.split(":");
            t2.setHours(parts[0], parts[1], 0, 0);

            var t3 = new Date();
            parts = endTime.split(":");
            t3.setHours(parts[0], parts[1], 0, 0);

            // returns 1 if greater, -1 if less and 0 if the same
            return (t1.getTime() >= t2.getTime() && t1.getTime() <= t3.getTime());
        },
        timeDiffInMinutes(slotTime, startTime) {

            if (slotTime == null) return 0;

            var t1 = new Date();
            var parts = slotTime.split(":");
            t1.setHours(parts[0], parts[1], 0, 0);

            var t2 = new Date();
            parts = startTime.split(":");
            t2.setHours(parts[0], parts[1], 0, 0);

            return parseInt(Math.abs(t1.getTime() - t2.getTime()) / (60 * 1000));
        },

        setGlobalFavorite(idStudent, isFavorite) {
            Vue.set(this.favorites, idStudent, isFavorite);
        },

        setGlobalVerified(id, value) {
            if (value) {
                this.setGlobalStatus(id, null);
            }
            Vue.set(this.verified, id, value);
        },

        setGlobalValidated(id, value) {
            if (value) {
                this.setGlobalStatus(id, null);
            }
            Vue.set(this.validated, id, value);
        },

        setGlobalStatus(id, status) {
            Vue.set(this.statuses, id, status);
        },

        toggleStudentSelection(id, name, event) {

            if (event.target.checked) {
                Vue.set(this.cvlib.selectedStudents, id, name);
            } else {
                Vue.delete(this.cvlib.selectedStudents, id);
            }
        },

        toggleItemSelection(id, name, event) {
            if (event.target.checked) {
                Vue.set(this.search.selectedItems, id, name);
            } else {
                Vue.delete(this.search.selectedItems, id);
            }
        },

        clearStudentSelection() {
            Object.keys(this.cvlib.selectedStudents).forEach((key) => {
                Vue.delete(this.cvlib.selectedStudents, key);
            });
        },

        clearItemSelection() {
            Object.keys(this.search.selectedItems).forEach((key) => {
                Vue.delete(this.search.selectedItems, key);
            });
        },

        inviteStudents(students) {
            this.cvlib.studentsToInvite = {};
            students.forEach((student) => {
                Vue.set(this.cvlib.studentsToInvite, student.id, student.name);
            });
            this.toggleAModal('modal__register');
        },

        inviteMultiSelectedStudent() {
            const studentArrayToInvite = [];
            Object.keys(this.cvlib.selectedStudents).forEach((id) => {
                studentArrayToInvite.push({'id': id, 'name': this.cvlib.selectedStudents[id]})
            });
            this.inviteStudents(studentArrayToInvite);
        },

        addToFavoriteMultiSelectedStudent(route) {
            const studentsArrayAddFavorite = [];
            Object.keys(this.cvlib.selectedStudents).forEach((id) => {
                studentsArrayAddFavorite.push(id)
            });
            //this.inviteStudents(studentArrayToInvite);
            axios.post(route, {
                    'students': studentsArrayAddFavorite
                }
            ).then((response) => {
                let favorites = response.data.favorites;
                favorites.forEach((favorite) => {
                    this.setGlobalFavorite(favorite.id, favorite.favorite)
                });
            }).catch(function (error) {
                // error management?
                console.log(error);
            });
        },

        setVerifiedStatusMultiSelectedCompanies(route) {
            Object.keys(this.search.selectedItems).forEach(id => {
                axios.post(route, {
                    item: id
                }).then(response => {
                    const isVerified = response.data.is_on;
                    this.setGlobalVerified(id, isVerified);
                }).catch(error => {
                    console.log(error);
                });
            });
        },

        setVisibilitySettingMultiSelectedForumActivities(route) {
            Object.keys(this.search.selectedItems).forEach(id => {
                axios.post(route, {
                    item: id
                }).then(response => {
                    const isVisible = response.data.is_on;
                    this.setGlobalVerified(id, isVisible);
                }).catch(error => {
                    console.log(error);
                });
            });
        },

        generateBills() {
            for (const companySubscriptionId of Object.keys(this.search.selectedItems)) {
                axios.post('/admin/bills/emit', {
                    'subscription': companySubscriptionId
                }).then(() => this.search.selectedItems[companySubscriptionId] = true);
            }
        },

        setActivitySelected(event) {
            /*this.cvlib.selectedActivity.needsSchedule = event.target.options[event.target.selectedIndex].dataset.needsschedule;
            this.cvlib.selectedActivity.needsDays = event.target.options[event.target.selectedIndex].dataset.needsdays;*/
        },
        checkValidity(ref) {
            if (this.$refs[ref]) {
                return !this.$refs[ref].checkValidity();
            }
            return true;
        },
        setExport() {
            this.$refs.export.value = 1;
            this.$refs.searchform.target = "_blank";
            this.$refs.searchform.submit();
            this.$refs.searchform.target = "_self";
            this.$refs.export.value = 0;
        },
        setOptExport() {
            this.$refs.opt_export.value = 1;
            this.$refs.searchform.target = "_blank";
            this.$refs.searchform.submit();
            this.$refs.searchform.target = "_self";
            this.$refs.opt_export.value = 0;
        },
        setAdminCreatePrestation() {
            if (this.admin.selectCompany != null) {
                window.open(this.admin.selectCompany.route, '_blank');
            }
        },
        goLink(path) {
            window.location.href = path;
        }

        /*   // helper's method translated in js, using accounting-js library
           /!**
            * @return {string}
            *!/
           CHF(amount){
                return formatMoney(amount, {symbol: 'CHF', precision: 2, thousand : "'" , decimal: ","}).concat('.-');
           },
           priceCHF(amount){
               return CHF(amount).replace('CHF', '');
           },
     */
    },
});

global.vm = vm;


/*****************************************
 * jQuery toggle mobile nav
 ******************************************/


$('.js-toggle-profilenav').on('click', function () {
    $('.mainnav').removeClass('isOpen');
    $('.profilenav .menu').toggleClass('isOpen');
})

$('.js-toggle-mainnav').on('click', function () {
    $('.profilenav .menu').removeClass('isOpen');
    $('.mainnav').toggleClass('isOpen');
})

var clipboard = new ClipboardJS('.clipbutton');

tippy(document.querySelectorAll('.clipbutton'), {
    trigger: 'click',
});

tippy('.studysections_description', {
    content: '',
    trigger: 'mouseenter',
});

